module.exports = __webpack_public_path__ + "img/elevator2.205c7aea.gif";